module.exports = __webpack_public_path__ + "img/concepcion_background_hero.a3640121.png";